module.exports = __webpack_public_path__ + "img/java.bbdd7ee2.svg";